// extracted by mini-css-extract-plugin
export default {"content":"noPage_content__dA-CH"};